import { render, staticRenderFns } from "./store-info-tab.vue?vue&type=template&id=384c5c07&scoped=true"
import script from "./store-info-tab.vue?vue&type=script&lang=js"
export * from "./store-info-tab.vue?vue&type=script&lang=js"
import style0 from "./store-info-tab.vue?vue&type=style&index=0&id=384c5c07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c5c07",
  null
  
)

export default component.exports